"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactDatepicker = _interopRequireDefault(require("react-datepicker"));
var _reactDeviceDetect = require("react-device-detect");
var _luxon = require("luxon");
var _lodash = require("lodash");
var _BrixelIcon = _interopRequireDefault(require("./BrixelIcon"));
var _helper = require("../utils/helper");
var _OutsideElement = _interopRequireDefault(require("./OutsideElement"));
var _translation = _interopRequireDefault(require("../Translation/translation"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function BrixelRangeDatePicker(props) {
  const {
    className = '',
    dateFormat = 'dd/MM/yyyy',
    hideInput = false,
    lang = 'ch',
    onChangeStartRange,
    onChangeEndRange,
    ref1 = null,
    ref2 = null,
    ref3 = null,
    ref4 = null,
    selectedStart = '',
    selectedEnd = '',
    showFullSelectDate = true
  } = props;
  // STATE
  const [startDate, setStartDate] = (0, _react.useState)('');
  const [startDateCal, setStartDateCal] = (0, _react.useState)('');
  const [endDate, setEndDate] = (0, _react.useState)('');
  const [endDateCal, setEndDateCal] = (0, _react.useState)('');
  const [locale, setLocale] = (0, _react.useState)('en');
  const [showStartDatePicker, setShowStartDatePicker] = (0, _react.useState)(false);
  const [showEndDatePicker, setShowEndDatePicker] = (0, _react.useState)(false);
  const localRef1 = ref1 || (0, _react.useRef)(null);
  const localRef2 = ref2 || (0, _react.useRef)(null);
  const localRef3 = ref3 || (0, _react.useRef)(null);
  const localRef4 = ref4 || (0, _react.useRef)(null);
  (0, _react.useEffect)(() => {
    if (lang && lang !== null) setLocale(lang.toLowerCase());
  }, [lang]);
  const range = (start, stop, step) => Array.from({
    length: (stop - start) / step + 1
  }, (_, i) => start + i * step);
  const years = range(1900, new Date().getFullYear() + 1, 1);
  const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  const onChangeStartDate = (val, action) => {
    let defVal = 0;
    if (action === 'cal' && typeof val !== 'string') {
      setStartDate(_luxon.DateTime.fromJSDate(val).toFormat('yyyy-LL-dd', {
        locale: lang || ''
      }));
      defVal = _luxon.DateTime.fromJSDate(val).toMillis();
    } else if (typeof val === 'string') {
      setStartDate(val);
      setStartDateCal(_luxon.DateTime.fromFormat(val, 'yyyy-LL-dd', {
        locale: lang || ''
      }).toJSDate());
      defVal = _luxon.DateTime.fromFormat(val, 'yyyy-LL-dd', {
        locale: lang || ''
      }).toMillis();
    }
    setShowStartDatePicker(false);
    if (defVal > 0) onChangeStartRange && onChangeStartRange(defVal);
  };
  const onChangeEndDate = (val, action) => {
    let defVal = 0;
    if (action === 'cal' && typeof val !== 'string') {
      setEndDate(_luxon.DateTime.fromJSDate(val).toFormat('yyyy-LL-dd', {
        locale: lang || ''
      }));
      defVal = _luxon.DateTime.fromJSDate(val).toMillis();
    } else if (typeof val === 'string') {
      setEndDate(val);
      setEndDateCal(_luxon.DateTime.fromFormat(val, 'yyyy-LL-dd', {
        locale: lang || ''
      }).toJSDate());
      defVal = _luxon.DateTime.fromFormat(val, 'yyyy-LL-dd', {
        locale: lang || ''
      }).toMillis();
    }
    setShowEndDatePicker(false);
    if (defVal > 0) onChangeEndRange && onChangeEndRange(defVal);
  };
  const onBlur = () => {
    if (startDate && endDate) {
      const startMillis = _luxon.DateTime.fromFormat(startDate, 'yyyy-LL-dd', {
        locale: lang || ''
      }).toMillis();
      const endMillis = _luxon.DateTime.fromFormat(endDate, 'yyyy-LL-dd', {
        locale: lang || ''
      }).toMillis();
      if (startMillis > endMillis) {
        setEndDate(startDate);
        setEndDateCal(_luxon.DateTime.fromJSDate(startDate).toFormat('yyyy-LL-dd', {
          locale: lang || ''
        }));
        setStartDate(endDate);
        setStartDateCal(_luxon.DateTime.fromJSDate(endDate).toFormat('yyyy-LL-dd', {
          locale: lang || ''
        }));
      }
      // const maxFormatDate = new Date(maxDate);
      // const millisDate = DateTime.fromFormat(valDate, 'yyyy-LL-dd', { locale: lang || '' }).toMillis();
      // const millisMaxDate = DateTime.fromJSDate(maxFormatDate).toMillis();
      // if (!isNaN(+millisMaxDate) && (isNaN(millisDate) || millisDate > millisMaxDate)) {
      //   onChangeInputDate(DateTime.fromMillis(millisMaxDate).toFormat('yyyy-LL-dd', { locale: lang || '' }), 'input');
      // }
    }
  };
  (0, _react.useEffect)(() => {
    if (selectedStart && !(0, _lodash.isNaN)(+selectedStart)) {
      setStartDateCal(_luxon.DateTime.fromMillis(selectedStart).toJSDate());
      setStartDate(_luxon.DateTime.fromMillis(selectedStart).toFormat('yyyy-LL-dd', {
        locale: lang || ''
      }));
    }
  }, [selectedStart]);
  (0, _react.useEffect)(() => {
    if (selectedEnd && !(0, _lodash.isNaN)(+selectedEnd)) {
      setEndDateCal(_luxon.DateTime.fromMillis(selectedEnd).toJSDate());
      setEndDate(_luxon.DateTime.fromMillis(selectedEnd).toFormat('yyyy-LL-dd', {
        locale: lang || ''
      }));
    }
  }, [selectedEnd]);
  const clickDate = e => {
    if (typeof window !== 'undefined') {
      if (!_reactDeviceDetect.isMobile) {
        e.preventDefault();
      }
    }
  };
  const toggleStartCalendar = () => {
    if (typeof window !== 'undefined') {
      if (!_reactDeviceDetect.isMobile) {
        setShowStartDatePicker(!showStartDatePicker);
      }
    }
  };
  const toggleEndCalendar = () => {
    if (typeof window !== 'undefined') {
      if (!_reactDeviceDetect.isMobile) {
        setShowEndDatePicker(!showEndDatePicker);
      }
    }
  };
  (0, _OutsideElement.default)(localRef1, {
    action: 'function',
    func: () => setShowStartDatePicker(false)
  });
  (0, _OutsideElement.default)(localRef3, {
    action: 'function',
    func: () => setShowEndDatePicker(false)
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    id: "wrapDatePicker",
    className: className
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "overlay dis-fl-row a-c"
  }, /*#__PURE__*/_react.default.createElement("div", {
    id: "fixedDatePicker",
    className: `${_reactDeviceDetect.isMobile ? 'mobiles' : ''}`,
    ref: localRef1
  }, !hideInput && (/*#__PURE__*/_react.default.createElement("div", {
    className: "pos-r h-perc-100"
  }, /*#__PURE__*/_react.default.createElement("input", {
    type: "date",
    value: startDate,
    onChange: e => onChangeStartDate(e.target.value, 'input'),
    onClick: e => clickDate(e),
    onBlur: () => onBlur()
  }), /*#__PURE__*/_react.default.createElement(_BrixelIcon.default, {
    onClick: () => toggleStartCalendar(),
    icon: "calendar",
    className: `${_reactDeviceDetect.isMobile ? 'notClickable' : ''} pos-a-fix x-r-2 x-t-1 zIndex1 w-fix-50 cur-poi`
  }))), (showStartDatePicker || hideInput) && (/*#__PURE__*/_react.default.createElement(_reactDatepicker.default, {
    className: "x-t-3",
    disabledKeyboardNavigation: true,
    renderCustomHeader: ({
      date,
      changeYear,
      changeMonth,
      decreaseMonth,
      increaseMonth,
      prevMonthButtonDisabled,
      nextMonthButtonDisabled
    }) => (/*#__PURE__*/_react.default.createElement("div", {
      style: {
        margin: 10,
        marginLeft: 5,
        marginRight: 5,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
      }
    }, /*#__PURE__*/_react.default.createElement("button", {
      type: "button",
      onClick: decreaseMonth,
      disabled: prevMonthButtonDisabled
    }, /*#__PURE__*/_react.default.createElement(_BrixelIcon.default, {
      iconWidth: "w-fix-16",
      icon: "chevron-left"
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: "w-perc-100 dis-f a-c jc-c"
    }, showFullSelectDate ? (/*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
      className: "wrap-select"
    }, /*#__PURE__*/_react.default.createElement("select", {
      className: "mr-1",
      value: new Date(date).getFullYear(),
      onChange: ({
        target: {
          value
        }
      }) => changeYear(+value)
    }, years.map((option, i) => (/*#__PURE__*/_react.default.createElement("option", {
      key: `slc_${i.toString()}`,
      value: option
    }, option))))), /*#__PURE__*/_react.default.createElement("div", {
      className: "wrap-select ml-1"
    }, /*#__PURE__*/_react.default.createElement("select", {
      value: months[new Date(date).getMonth()],
      onChange: ({
        target: {
          value
        }
      }) => changeMonth(months.indexOf(value))
    }, months.map((option, i) => (/*#__PURE__*/_react.default.createElement("option", {
      key: `mnt_${i.toString()}`,
      value: option
    }, (0, _helper.capitalizeFirstLetter)(new Date(`${i + 1}/${i + 1}/2020`).toLocaleString(lang || 'en', {
      month: 'long'
    }))))))))) : (/*#__PURE__*/_react.default.createElement("span", null, (0, _helper.capitalizeFirstLetter)(date.toLocaleString(lang || 'en', {
      month: 'long'
    })), " ", date && new Date(date).getFullYear()))), /*#__PURE__*/_react.default.createElement("button", {
      type: "button",
      onClick: increaseMonth,
      disabled: nextMonthButtonDisabled
    }, /*#__PURE__*/_react.default.createElement(_BrixelIcon.default, {
      iconWidth: "w-fix-16",
      icon: "chevron-right"
    })))),
    placeholderText: dateFormat || undefined,
    dateFormat: dateFormat || undefined,
    inline: true,
    ref: localRef2,
    calendarStartDay: 1,
    locale: locale,
    selected: startDate,
    onChange: day => onChangeStartDate(day, 'cal'),
    selectsStart: true,
    startDate: startDateCal,
    endDate: endDateCal
  }))), "\u00A0", /*#__PURE__*/_react.default.createElement("span", null, (0, _translation.default)('to', lang || '')), "\u00A0", /*#__PURE__*/_react.default.createElement("div", {
    id: "fixedDatePicker",
    className: `${_reactDeviceDetect.isMobile ? 'mobiles' : ''}`,
    ref: localRef3
  }, !hideInput && (/*#__PURE__*/_react.default.createElement("div", {
    className: "pos-r h-perc-100"
  }, /*#__PURE__*/_react.default.createElement("input", {
    type: "date",
    value: endDate,
    onChange: e => onChangeEndDate(e.target.value, 'input'),
    onClick: e => clickDate(e),
    onBlur: () => onBlur()
  }), /*#__PURE__*/_react.default.createElement(_BrixelIcon.default, {
    onClick: () => toggleEndCalendar(),
    icon: "calendar",
    className: `${_reactDeviceDetect.isMobile ? 'notClickable' : ''} pos-a-fix x-r-2 x-t-1 zIndex1 w-fix-50 cur-poi`
  }))), (showEndDatePicker || hideInput) && (/*#__PURE__*/_react.default.createElement(_reactDatepicker.default, {
    className: "x-t-3",
    disabledKeyboardNavigation: true,
    renderCustomHeader: ({
      date,
      changeYear,
      changeMonth,
      decreaseMonth,
      increaseMonth,
      prevMonthButtonDisabled,
      nextMonthButtonDisabled
    }) => (/*#__PURE__*/_react.default.createElement("div", {
      style: {
        margin: 10,
        marginLeft: 5,
        marginRight: 5,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
      }
    }, /*#__PURE__*/_react.default.createElement("button", {
      type: "button",
      onClick: decreaseMonth,
      disabled: prevMonthButtonDisabled
    }, /*#__PURE__*/_react.default.createElement(_BrixelIcon.default, {
      iconWidth: "w-fix-16",
      icon: "chevron-left"
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: "w-perc-100 dis-f a-c jc-c"
    }, showFullSelectDate ? (/*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
      className: "wrap-select"
    }, /*#__PURE__*/_react.default.createElement("select", {
      className: "mr-1",
      value: new Date(date).getFullYear(),
      onChange: ({
        target: {
          value
        }
      }) => changeYear(+value)
    }, years.map((option, i) => (/*#__PURE__*/_react.default.createElement("option", {
      key: `slc_${i.toString()}`,
      value: option
    }, option))))), /*#__PURE__*/_react.default.createElement("div", {
      className: "wrap-select ml-1"
    }, /*#__PURE__*/_react.default.createElement("select", {
      value: months[new Date(date).getMonth()],
      onChange: ({
        target: {
          value
        }
      }) => changeMonth(months.indexOf(value))
    }, months.map((option, i) => (/*#__PURE__*/_react.default.createElement("option", {
      key: `mnt_${i.toString()}`,
      value: option
    }, (0, _helper.capitalizeFirstLetter)(new Date(`${i + 1}/${i + 1}/2020`).toLocaleString(lang || 'en', {
      month: 'long'
    }))))))))) : (/*#__PURE__*/_react.default.createElement("span", null, (0, _helper.capitalizeFirstLetter)(date.toLocaleString(lang || 'en', {
      month: 'long'
    })), " ", date && new Date(date).getFullYear()))), /*#__PURE__*/_react.default.createElement("button", {
      type: "button",
      onClick: increaseMonth,
      disabled: nextMonthButtonDisabled
    }, /*#__PURE__*/_react.default.createElement(_BrixelIcon.default, {
      iconWidth: "w-fix-16",
      icon: "chevron-right"
    })))),
    placeholderText: dateFormat || undefined,
    dateFormat: dateFormat || undefined,
    inline: true,
    ref: localRef4,
    calendarStartDay: 1,
    locale: locale,
    selected: endDate,
    onChange: day => onChangeEndDate(day, 'cal'),
    selectsEnd: true,
    startDate: startDateCal,
    endDate: endDateCal,
    minDate: startDate
  })))));
}
var _default = exports.default = BrixelRangeDatePicker;